
















































import { Component, Inject, Mixins } from "vue-property-decorator";
import { IAffiliateProvider } from "@/models/providers/affiliate";
import Context from "@/mixins/context";
import { ClientRoutes } from "@/data/enums/router";
import { Location as VueLocation } from "vue-router";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class AffiliateStatsGrid extends Mixins(Context) {
  // Inject

  @Inject({ from: "affiliateProvider" })
  public readonly affiliateProvider!: () => IAffiliateProvider;

  // Computed

  public get $affiliateData() {
    return this.affiliateProvider();
  }

  public get affiliateCommissionsRoute(): VueLocation {
    return {
      name: this.isAdmin
        ? "adminClientAffiliateCommissions"
        : ClientRoutes.AFFILIATE_COMMISSIONS
    };
  }

  public get affiliatePayoutsRoute(): VueLocation {
    return {
      name: this.isAdmin
        ? "adminClientAffiliatePayouts"
        : ClientRoutes.AFFILIATE_PAYOUTS
    };
  }
}
